var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from '@mui/material';
import React from 'react';
import { getAttributes, ThemeUtils } from '../../../utils';
import { Container, ContainerBorderRadiuses, ContainerDisplays, ContainerFlexDirections, ContainerFlexGaps, ContainerOverflows, ContainerWidths } from '../../templates/container';
import { Sizes } from '../../types';
var BarSegmentGroup = styled(Container, {
    name: 'BarSegmentGroup',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var BarSegment = styled(Container, {
    name: 'BarSegment',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var PB = function (_a) {
    var props = __rest(_a, []);
    var value = props.value, scale = props.scale, _b = props.fluid, fluid = _b === void 0 ? true : _b, rest = __rest(props, ["value", "scale", "fluid"]);
    var barSegmentGroupConfig = __assign(__assign({ display: ContainerDisplays.Flex, flexDirection: ContainerFlexDirections.Row, flexGap: ContainerFlexGaps.Size_1, overflow: ContainerOverflows.Hidden, borderRadius: ContainerBorderRadiuses.Size_4 }, (fluid && {
        width: ContainerWidths.Full
    })), getAttributes(rest));
    var getBarSegmentConfig = function (active, index) { return (__assign({ key: "segment-".concat(index), className: active ? 'active' : 'inactive' }, (fluid
        ? { flexGrow: 1 }
        : { width: ThemeUtils.getComputedSpacing(+Sizes.Size_3) }))); };
    var items = Array.from(Array(scale).keys()).map(function (item) { return ({
        active: item < value
    }); });
    return (React.createElement(BarSegmentGroup, __assign({}, barSegmentGroupConfig), items.map(function (item, index) { return (React.createElement(BarSegment, __assign({}, getBarSegmentConfig(item.active, index)))); })));
};
export { PB as ProgressBar };
